import React, { useState, useEffect } from "react";
import PricingPackages from "./PricingBlock_FinalWithButtons";
import "./App.css";
const navigationLinks = [
  { href: "#about", label: "Про нас" },
  { href: "#why", label: "Чому обирають нас" },
  { href: "#steps", label: "Як ми працюємо" },
  { href: "#examples", label: "Приклади" },
  { href: "#export", label: "Експорт" },
  { href: "#faq", label: "FAQ" },
  { href: "#packages", label: "Пакети" },
  { href: "#contact", label: "Контакти" },
];

function AccordionItem({ question, answer }) {
  const [open, setOpen] = useState(false);

  return (
    <div className="border-b border-gray-600 py-4">
      <div
        style={{ cursor: "pointer", display: "flex", justifyContent: "center", alignItems: "center" }}
        onClick={() => setOpen(!open)}
      >
        <h3 style={{ fontSize: "18px", fontWeight: "bold", color: "#facc15", margin: 16 }}>
          {question}
        </h3>
        <span style={{ color: "#22c55e", fontSize: "20px", fontWeight: "bold" }}>{open ? "▲" : "▼"}</span>
      </div>
      {open && <p style={{ marginTop: "8px", color: "#fff", fontSize: "18px" }}>{answer}</p>}
    </div>
  );
}





export default function HomePage() {
const [formSuccess, setFormSuccess] = useState(false);
const [menuOpen, setMenuOpen] = useState(false);
const [activeSection, setActiveSection] = useState("");

useEffect(() => {
  const sections = document.querySelectorAll("section[id], footer[id]");

  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          setActiveSection(entry.target.id);
        }
      });
    },
    { threshold: 0.3 }
  );

  sections.forEach((section) => observer.observe(section));

  // Отслеживаем, когда пользователь доскроллил до самого низа
  const handleScroll = () => {
    const scrollY = window.scrollY;
    const windowHeight = window.innerHeight;
    const fullHeight = document.body.scrollHeight;

    if (scrollY + windowHeight >= fullHeight - 10) {
      setActiveSection("contact"); // Вручную активируем футер
    }
  };

  window.addEventListener("scroll", handleScroll);

  return () => {
    observer.disconnect();
    window.removeEventListener("scroll", handleScroll);
  };
}, []);

const scrollToForm = (selectedPackage) => {
    const target = document.getElementById("request-form");
    if (target) {
      target.scrollIntoView({ behavior: "smooth" });
    }
  };
  return (
    <div style={{ backgroundColor: "#000", color: "#fff", fontFamily: "sans-serif", minHeight: "100vh" }}>
      
<nav
  style={{
    position: "fixed",
    top: 0,
    left: 0,
    width: "100%",
    backgroundColor: "#121212",
    padding: "20px 32px",
    zIndex: 1000,
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    flexWrap: "nowrap",
    boxSizing: "border-box",
  }}
>
  {/* Левая часть: бургер-иконка на мобильных */}
  <div className="md:hidden" style={{ display: "block" }}>
    <button onClick={() => setMenuOpen(!menuOpen)} style={{ color: "#facc15", fontSize: "28px", border: "none", background: "none" }}>
      ☰
    </button>
  </div>

  {/* Центр: меню (desktop only) */}
  <div className="hidden md:flex" style={{ display: "none" }}>
    {navigationLinks.map((link) => (
      <a
        key={link.href}
        href={link.href}
        className={`nav-link ${activeSection === link.href.slice(1) ? "active" : ""}`}
        style={{ color: "#fff", textDecoration: "none", fontWeight: "bold", marginRight: "16px" }}
      >
        {link.label}
      </a>
    ))}
  </div>

  {/* Правая часть: языки */}
  <div style={{ display: "flex", gap: "12px" }}>
    <a href="/" style={{ color: "#facc15", fontWeight: "bold", textDecoration: "none" }}>UA</a>
    <a href="/ru" style={{ color: "#facc15", fontWeight: "bold", textDecoration: "none" }}>RU</a>
  </div>
</nav>

{menuOpen && (
  <div
    style={{
      position: "fixed",
      top: 0,
      right: 0,
      width: "70%",
      height: "100%",
      backgroundColor: "#1a1a1a",
      zIndex: 999,
      padding: "30px 20px",
      display: "flex",
      flexDirection: "column",
      gap: "20px",
      transition: "right 0.3s ease-in-out",
    }}
  >
    <button onClick={() => setMenuOpen(false)} style={{ alignSelf: "flex-end", fontSize: "24px", color: "#facc15", background: "none", border: "none" }}>
      ✕
    </button>
    {navigationLinks.map((link) => (
      <a
        key={link.href}
        href={link.href}
        onClick={() => setMenuOpen(false)}
        style={{
          color: "#facc15",
          fontWeight: "bold",
          fontSize: "18px",
          textDecoration: "none",
        }}
      >
        {link.label}
      </a>
    ))}
  </div>
)}




      <section style={{ padding: "0px 20px 80px", textAlign: "center" }}>
        <img
          src="/images/logo-transparent.png"
          alt="Autopodbor.lt Logo"
          style={{ width: "100%", maxWidth: "400px", height: "auto", marginBottom: "-30px" }}
        />
        <h1 style={{ fontSize: "36px", fontWeight: "bold", marginBottom: "20px" }}>
          Професійний автопідбір у Литві та на експорт
        </h1>
        <p style={{ color: "#ccc", fontSize: "18px", marginBottom: "30px" }}>
          Технічна перевірка, перевірені авто, чесні звіти.
        </p>
        <a href="#request-form">
          <button style={{
            backgroundColor: "#facc15",
            color: "#000",
            padding: "12px 24px",
            fontWeight: "bold",
            borderRadius: "8px",
            cursor: "pointer",
            border: "none"
          }}>
            Залишити заявку
          </button>
        </a>
      </section>

      <section id="about" style={{ padding: "120px 20px", textAlign: "center", backgroundColor: "#121212" }}>
        <h2 style={{ fontSize: "32px", marginBottom: "30px" }}>Про нас</h2>
        <p style={{ maxWidth: "800px", margin: "0 auto", fontSize: "18px", color: "#fff" }}>
          Autopodbor.lt — Це команда професіоналів з досвідом понад 10 років у сфері автопідбору та діагностики, а також експорту автомобілів в Україну.
Ми підбираємо авто з чесною історією, проводимо повну перевірку та супроводжуємо клієнта на всіх етапах покупки — від дзвінка до передачі автомобіля.
        </p>
      </section>

      <section id="why" style={{ padding: "120px 20px", textAlign: "center" }}>
        <h2 style={{ fontSize: "32px", marginBottom: "30px" }}>Чому обирають бирают нас</h2>
        <div style={{
          maxWidth: "800px",
          margin: "0 auto",
          display: "flex",
          flexDirection: "column",
          gap: "0px",
          fontSize: "18px",
          lineHeight: "1.6",
          color: "#fff"
        }}>
          <p>🇱🇹 Ми знаходимося та працюємо в Литві, а не живемо в готелях за рахунок операційного бюджету. Ми досконало знаємо місцевий ринок зсередини, а також його сезонні коливання: де шукати хороші автомобілі, яких просто немає в інтернеті й які розпродаються автовозами, які місця краще оминати, а куди взагалі не варто навіть дивитися.</p>
          <p>📊 Ми чудово розуміємо ринкові ціни, «дно» та «стелю» вартості автомобіля. Це дозволяє точно визначити, чи вартий конкретний екземпляр своїх грошей.</p>
          <p>🔧 Багаторічний досвід дозволяє «побачити проблемне авто за версту», а наявність професійного обладнання та досконалі знання, як ним користуватися, — виявити приховані технічні несправності, включно з помилками, станом рідин, шин, акумулятора та багато іншого.</p>
          <p>🌍 Ринок Литви на 70–80% складається з автомобілів, привезених із Західної Європи. Тут особливо важливі навички та досвід, щоб обрати не просто гарну обгортку з пробігом 500+ тис. км, а надійний автомобіль із реальним пробігом і зрозумілою історією.</p>
          <p>⚖️ Ми також перевіряємо юридичну чистоту автомобіля, щоб захистити клієнта від придбання проблемного або кримінального авто.</p>
        </div>
      </section>

      <section id="steps" style={{ padding: "120px 20px", textAlign: "center", backgroundColor: "#121212" }}>
        <h2 style={{ fontSize: "32px", marginBottom: "40px" }}>Як ми працюємо</h2>
        <ol style={{ maxWidth: "600px", margin: "0 auto", textAlign: "left", fontSize: "18px", lineHeight: 2 }}>
          <li>
            Ви залишаєте заявку, прикріпивши посилання на автомобіль, який вас цікавить, з сайтів{" "}
            <a href="https://www.autoplius.lt" target="_blank" rel="noopener noreferrer" style={{ color: "#facc15", textDecoration: "underline" }}>
              www.autoplius.lt
            </a>{" "}
            або{" "}
            <a href="https://www.autogidas.lt" target="_blank" rel="noopener noreferrer" style={{ color: "#facc15", textDecoration: "underline" }}>
              www.autogidas.lt
            </a>, Або без посилання, якщо ви ще не визначилися з вибором.
          </li>
          <li>
            Ми уточнюємо деталі, бюджет, ваші потреби, консультуємо та допомагаємо визначитися з{" "}
            <a href="#packages" style={{ color: "#facc15", textDecoration: "underline" }}>
              пакетом послуг
            </a>.
          </li>
          <li>Після того як ми узгодили всі деталі та визначилися з послугою, ви оплачуєте обраний пакет.</li>
          <li>
  Аналізуємо пропозиції на ринку, шукаємо авто, проводимо перевірку відповідно до обраного пакета послуг. Якщо ви обрали пакет{" "}
  <span style={{ color: "#facc15", fontWeight: "bold" }}>STANDART</span> або{" "}
  <span style={{ color: "#facc15", fontWeight: "bold" }}>PROFI</span>, Наш спеціаліст надає вам звіт протягом{" "}
  <span style={{ color: "#facc15" }}>24 годин</span> після оплати відповідного пакета.
</li>

          <li>
            Якщо після наданого звіту від спеціаліста <strong>Autopodbor.lt</strong> ви приймаєте рішення про глибшу діагностику, викуп або імпорт авто (тобто про перехід на вищий пакет), ви просто доплачуєте різницю між пакетами.
          </li>
          <li>
            Передаємо авто, готуємо до реєстрації, оформлюємо експорт/імпорт, організовуємо доставку разом з правом власності. Усе — згідно з вашими побажаннями та обраним пакетом послуг.
          </li>
        </ol>
      </section>

      <section id="examples" style={{ padding: "120px 20px", textAlign: "center" }}>
  <h2 style={{ fontSize: "32px", marginBottom: "40px" }}>Приклади підібраних авто</h2>
  <p style={{ color: "#fff", maxWidth: "700px", margin: "0 auto 30px", lineHeight: "1.6", fontSize: "18px" }}>
    Ми не використовуємо випадкові фотографії чи вигадані кейси з неіснуючими відгуками — натомість показуємо реальні історії з нашої роботи.
Щодня публікуємо підбори, діагностики, огляди, угоди, доставку, а також автомобільний live-контент у нашому TikTok-каналі.

    Це не вітрина з гарними картинками — це живе підтвердження того, що ми справді працюємо в Литві, підбираємо автомобілі та чесно показуємо весь процес.

Якщо хочеш побачити, як ми працюємо, кого обслуговуємо та які авто насправді знаходимо — просто зазирни до нашого TikTok. Там усе по-справжньому.
  </p>

 <a
  href="https://www.tiktok.com/@autopodbor.lt"
  target="_blank"
  rel="noopener noreferrer"
  style={{
    display: "inline-flex",
    alignItems: "center",
    backgroundColor: "#1a1a1a",
    color: "#facc15",
    padding: "12px 20px",
    border: "2px solid #facc15",
    borderRadius: "10px",
    fontWeight: "bold",
    fontSize: "16px",
    textDecoration: "none"
  }}
>
  {/* Логотип */}
  <img
    src="/images/logo-transparent.png"
    alt="Autopodbor.lt"
    style={{ width: "80px", height: "80px", marginRight: "10px", objectFit: "contain" }}
  />

  {/* Иконка TikTok */}
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 256 256"
    fill="#facc15"
    style={{ marginRight: "10px" }}
  >
    <path d="M224,80a48.05,48.05,0,0,1-48-48,8,8,0,0,0-8-8H136a8,8,0,0,0-8,8V160a24,24,0,1,1-24-24,8,8,0,0,0,0-16,40,40,0,1,0,40,40V88.29A95.6,95.6,0,0,0,192,104a96.11,96.11,0,0,0,32-5.54,8,8,0,0,0,0-15.1A80.22,80.22,0,0,1,224,80Z"/>
  </svg>

  Дивитися TikTok
</a>

</section>


     <section id="export" style={{ padding: "120px 20px", textAlign: "center", backgroundColor: "#121212" }}>
  <h2 style={{ fontSize: "32px", marginBottom: "40px" }}>Експорт автомобілів</h2>
  
  <div style={{ maxWidth: "900px", margin: "0 auto", textAlign: "left", color: "#fff", fontSize: "18px", lineHeight: "1.8" }}>

    <p style={{ marginBottom: "30px" }}>
      Литва вже багато років вважається <span style={{ color: "#facc15", fontWeight: "bold" }}>експортним хабом всієї Європи</span>. Через неї щороку проходять сотні тисяч автомобілів — і на це є вагомі причини.
    </p>

    <p style={{ marginBottom: "30px" }}>
      По-перше, <span style={{ color: "#facc15" }}>ремонт і передпродажна підготовка в Литві значно дешевші</span>, ніж у Німеччині, Бельгії чи Нідерландах. Саме тут вигідно виконувати дрібні кузовні та технічні роботи перед відправкою автомобіля кінцевому покупцеві.
    </p>

    <p style={{ marginBottom: "30px" }}>
      По-друге, в Литві вже давно налагоджена зручна інфраструктура для експорту: склади, логістика, автовози, перегонники, оформлення транзитних номерів, експортних декларацій і страхувань — усе це робиться швидко та за відпрацьованою схемою.
    </p>

    <p style={{ marginBottom: "30px" }}>
      Завдяки цьому Литва стала ключовим вузлом не лише для країн СНД, а й для <span style={{ color: "#facc15" }}>реекспорту</span> назад до Західної Європи. Так, навіть дилери з Німеччини, Польщі, Чехії викуповують автомобілі тут — після місцевої підготовки вони стають вигідними навіть для західного ринку.
    </p>

    <h3 style={{ fontSize: "24px", marginTop: "60px", marginBottom: "20px", color: "#fff" }}>🌍 Основні напрямки експорту</h3>
    <ul style={{ paddingLeft: "20px", marginBottom: "30px" }}>
      <li style={{ marginBottom: "10px" }}>🇺🇦 <strong>Україна</strong> — основний ринок. Ми супроводжуємо експорт «під ключ».</li>
      <li style={{ marginBottom: "10px" }}>🇰🇿 Казахстан</li>
      <li style={{ marginBottom: "10px" }}>🇧🇾 Білорусь</li>
      <li style={{ marginBottom: "10px" }}>🇪🇺 Країни Західної Європи (реекспорт)</li>
    </ul>

    <p style={{ marginBottom: "10px" }}>
      Ми беремо на себе <span style={{ color: "#facc15" }}>все</span>: підбір авто, оформлення документів, експортні номери, страхування, логістику та передачу автомобіля. 
    </p>
    <p style={{ marginBottom: "10px" }}>
      Працюємо з фото- та відеозвітами, координуємо процеси на кордоні та завжди тримаємо клієнта в курсі.
    </p>

    <p style={{ marginTop: "30px" }}>
      Хочете експортувати автомобіль з Литви? Просто скажіть — ми все організуємо.
    </p>

  </div>
</section>


      <section id="faq" style={{ padding: "120px 20px", textAlign: "center" }}>
  <h2 style={{ fontSize: "32px", marginBottom: "40px" }}>Часті запитання</h2>
  <div className="max-w-3xl mx-auto text-left">
    {[
      {
        q: "Скільки триває підбір автомобіля?",
        a: "Зазвичай підбір займає від 1 до 15 робочих днів, залежно від ваших вимог і бюджету.",
      },
      {
        q: "Де ви підбираєте автомобілі?",
        a: "Ми підбираємо автомобілі в Литві. Основна маса авто надходить із Німеччини, Бельгії, Нідерландів та Франції.",
      },
      {
        q: "Як перевіряється автомобіль перед покупкою?",
        a: "Ми перевіряємо історію за VIN, юридичну чистоту, технічний стан, зовнішній вигляд і проводимо тест-драйв. Детальніше ознайомитися з етапами перевірки можна в розділі «Як ми працюємо» та в описі обраного пакета послуг.",
      },
      {
        q: "Ви допомагаєте з реєстрацією автомобіля?",
        a: "Так, беремо на себе всю процедуру реєстрації в Литві та Україні — від підготовки документів до постановки на облік.",
      },
      {
       q: "Які документи я отримаю при покупці?",
       a: "Повний комплект: договір купівлі-продажу, техпаспорт, техогляд (якщо є), сертифікат COC, сертифікат відповідності, імпортна декларація, а також наш детальний звіт про перевірку автомобіля.",
      },
      {
        q: "Чи можна замовити підбір дистанційно?",
a: "Звісно! Усе спілкування відбувається онлайн. Ви отримуєте фото, відео та звіти по кожному запропонованому варіанту.",
      },
      {
        q: "А якщо мені не підійде жоден із варіантів?",
a: "Ми працюємо до переможного результату або до того моменту, поки клієнт сам не зупинить процес з особистих причин. У разі припинення підбору за ініціативою клієнта, повернення коштів здійснюється з урахуванням перерахунку оплаченого пакета та обсягу виконаних робіт.",
      },
      {
        q: "Які гарантії ви надаєте?",
a: "Ми працюємо відповідно до публічної оферти, з якою можна ознайомитися у відповідному розділі сайту.",
      },
    ].map((item, i) => (
      <AccordionItem key={i} question={item.q} answer={item.a} />
    ))}
  </div>
</section>


      <section id="packages">
  <PricingPackages scrollToForm={scrollToForm} />
</section>

      <section id="request-form" style={{ backgroundColor: "#121212", padding: "100px 20px", textAlign: "center" }}>
        <h2 style={{ fontSize: "32px", marginBottom: "30px", color: "#fff" }}>Залишити заявку</h2>
        <form
          onSubmit={async (e) => {
const form = e.target;
            e.preventDefault();const isBot = form.website.value;
if (isBot) return;

         
            const name = form.name.value;
            const phone = form.phone.value;
            const budget = form.budget.value;
            const selectedPackage = form.package.value;
            const comment = form.comment.value;

            const message = `📥 Нова заявка з сайту Autopodbor.lt\n👤 Ім'я: ${name}\n📞 Телефон: ${phone}\n💰 Бюджет: ${budget}\n📦 Пакет: ${selectedPackage}\n📝 Комментар: ${comment || "—"}`;

            const botToken = "7729228635:AAGPTRp2Lo-gZ1tKpriWZKXTWKLZQX3okus";
            const chatId = "6180743887";

            const url = `https://api.telegram.org/bot${botToken}/sendMessage`;

            await fetch(url, {
              method: "POST",
              headers: {
                "Content-Type": "application/json",
              },
              body: JSON.stringify({
                chat_id: chatId,
                text: message,
              }),
            });

            setFormSuccess(true);
           form.reset();
          }}
          style={{ maxWidth: "500px", margin: "0 auto", display: "flex", flexDirection: "column", gap: "16px" }}
        >
          <input type="text" name="name" placeholder="Ваше ім'я" required style={{ padding: "12px", borderRadius: "8px", border: "none" }} />
          <input type="tel" name="phone" placeholder="Телефон або WhatsApp" required style={{ padding: "12px", borderRadius: "8px", border: "none" }} />
          <input type="text" name="budget" placeholder="Бюджет (наприклад, 7000 €)" required style={{ padding: "12px", borderRadius: "8px", border: "none" }} />
          <select name="package" defaultValue="" required style={{ padding: "12px", borderRadius: "8px", border: "none" }}>
            <option value="" disabled>Оберіть пакет</option>
            <option value="standart">STANDART (100€ + паливо)</option>
            <option value="profi">PROFI (200€ + паливо)</option>
            <option value="premium">PREMIUM (500€ + паливо)</option>
            <option value="vip">VIP «ALL IN» (от 1500€)</option>
          </select>
          <textarea name="comment" placeholder="Комментар (побажання щодо авто, посилання тощо.)" rows="4" style={{ padding: "12px", borderRadius: "8px", border: "none" }} />
<input
  type="text"
  name="website"
  style={{ display: "none" }}
  tabIndex="-1"
  autoComplete="off"
/>
          <button type="submit" style={{ backgroundColor: "#facc15", color: "#000", padding: "14px", fontWeight: "bold", borderRadius: "8px", cursor: "pointer", border: "none", fontSize: "16px" }}>
            Відправити заявку
          </button>
{formSuccess && (
  <p style={{ color: "#22c55e", fontWeight: "bold", marginTop: "20px" }}>
    ✅ Заявку успішно надіслано!
  </p>
)}

        </form>
      </section>

      <footer id="contact" style={{
        backgroundColor: "#1a1a1a",
        padding: "40px 20px",
        display: "flex",
        justifyContent: "center",
        gap: "100px",
        alignItems: "center",
        flexWrap: "wrap",
        color: "#888",
        minHeight: "200px"
      }}>
        <div style={{ textAlign: "left" }}>
          <p>
            © {new Date().getFullYear()} Autopodbor.lt — Усі права захищено
            <br />
            <a href="/oferta" style={{ color: "#facc15", fontSize: "14px", textDecoration: "underline" }}>
              Публічна оферта
            </a>
          </p>
          <a href="https://www.tiktok.com/@autopodbor.lt" target="_blank" rel="noopener noreferrer" style={{ display: "inline-flex", alignItems: "center", gap: "8px", color: "#ef4444", textDecoration: "none", fontSize: "20px" }}>
            <svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 24 24" fill="currentColor">
              <path d="M16 8.245c1.516 1.005 3.117 1.53 4.932 1.625v3.084c-1.79-.057-3.37-.57-4.932-1.464v5.38c0 5.738-6.663 7.68-9.936 3.454-3.097-3.99-.588-10.253 4.68-10.457v3.163c-2.82.247-3.58 3.162-1.656 4.59 1.735 1.286 3.912-.44 3.912-2.642v-14.978h3.996c.11 2.348.953 4.184 3.004 5.345v3.06c-1.17-.032-2.286-.254-3.392-.687z"/>
            </svg>
            @autopodbor.lt — Наш TikTok канал
          </a>
        </div>

        <div style={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
          <img src="/images/logo-transparent.png" alt="Logo" width="100" height="auto" />
          <p style={{ fontSize: "12px", marginTop: "8px" }}>info@autopodbor.lt</p>
          <p style={{ fontSize: "12px", margin: 0 }}>+37061744495</p>
          <p style={{ fontSize: "12px", margin: 0 }}>+380681016108</p>
        </div>

        <div style={{ textAlign: "right", display: "flex", flexDirection: "column", gap: "10px" }}>
          <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
            <img src="/images/whatsapp-icon.svg" alt="WhatsApp" width="60" height="60" />
            <span>+37061744495</span>
          </div>
          <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
            <img src="/images/telegram-icon.svg" alt="Telegram" width="60" height="60" />
            <span>+380681016108</span>
          </div>
        </div>
      </footer>
    </div>
  );
}
